import React from 'react';
import DonutGraph from './DonutGraph/DonutGraph';
import BarGraph from './BarGraph/BarGraph';
import LineGraph from './LineGraph.js/LineGraph';
import PieChart   from './PieChart/PieChart';
import PolarGraph from './PolarGraph/PolarGraph';

const GraphFactory = React.forwardRef((props, ref)=> {
    const {type, data, text, stack} = props;

    if (type) {
        switch(type.toLowerCase()) {
            case "bar":
                return <BarGraph id="graph" ref={ref} data={data} text={text} stack={stack}></BarGraph>
            case "donut":
                return <DonutGraph id="graph" ref={ref} data={data} text={text}></DonutGraph>
            case "line":
                return <LineGraph id="graph" ref={ref} data={data} text={text} stack={stack}></LineGraph>
            case "pie":
                return <PieChart id="graph" ref={ref} data={data} text={text}></PieChart>
            case "polar":
                return <PolarGraph id="graph" ref={ref} data={data} text={text}></PolarGraph>
            default:
                return <>No graph found</>
        }
    }
});
  
export default GraphFactory;